import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { AlertTriangle, CheckCircle2, ArrowRight } from "lucide-react";
import { blockedExpenseReason } from "@/lib/expenseRules";

export function pendingItems(app) {
  const docs = (app.documents || []).filter((d) => d.scope === "income" || d.scope === "other_income");
  const has = (id) => docs.some((d) => d.adult_id === id);
  const items = [];
  (app.income?.adults || []).forEach((a) => {
    if (!has(a.id)) items.push({ step: 2, text: `Falta el respaldo de ingresos de ${a.nombre || "un integrante que aporta ingresos"}.` });
  });
  (app.income?.others || []).forEach((o) => {
    if ((o.amount || 0) > 0 && !has(o.id)) items.push({ step: 2, text: `Falta el respaldo del ingreso "${o.tipo || "otro ingreso"}".` });
  });
  (app.expenses || []).forEach((e) => {
    const r = blockedExpenseReason(e);
    if (r) items.push({ step: 3, text: `Gasto no aceptado como excepcional (${r}): "${(e.description || "").slice(0, 60)}". Elimínalo.` });
  });
  return items;
}

export const SubmitChecklist = ({ app, goStep }) => {
  const [familyErrors, setFamilyErrors] = useState(null);
  useEffect(() => {
    api.get(`/applications/${app.id}/precheck`).then((r) => setFamilyErrors(r.data.family_errors || [])).catch(() => setFamilyErrors(["No pudimos revisar los datos del grupo familiar. Revisa el paso 1."]));
  }, [app.id]);
  if (familyErrors === null) return null;
  const items = [...familyErrors.map((text) => ({ step: 1, text })), ...pendingItems(app)];
  if (!items.length) {
    return (
      <section className="rounded-2xl border border-emerald-200 bg-emerald-50 p-5 flex gap-3 text-emerald-900" data-testid="submit-checklist-ok">
        <CheckCircle2 className="w-5 h-5 shrink-0 mt-0.5" />
        <p className="text-sm">Datos del grupo familiar, documentos de ingresos y gastos en orden.</p>
      </section>
    );
  }
  return (
    <section className="rounded-2xl border border-red-300 bg-red-50 p-5 text-red-900" data-testid="submit-checklist">
      <div className="flex items-center gap-2 mb-3">
        <AlertTriangle className="w-5 h-5" />
        <h2 className="text-base font-semibold">Antes de enviar, corrige lo siguiente</h2>
      </div>
      <ul className="space-y-2">
        {items.map((it, i) => (
          <li key={i} className="flex flex-wrap items-start justify-between gap-2 text-sm" data-testid={`submit-checklist-item-${i}`}>
            <span className="flex-1 min-w-[200px]">{it.text}</span>
            <button type="button" onClick={() => goStep(it.step)} className="inline-flex items-center gap-1 font-semibold underline" data-testid={`submit-checklist-go-${i}`}>
              Ir al paso {it.step} <ArrowRight className="w-3.5 h-3.5" />
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
};
